// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2QCQD","selected":"Chip_selected__1sCnr"};